import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { InsightsState } from 'app-redux/InsightsState';
import {
  DiseaseActivitiesGlobalSortOptions,
  DiseaseListSortOptionValues,
} from 'models/SortByOptions';

import { ViewPanelDropdown } from 'components/_controls/ViewPanelDropdown';

import diseaseActivitiesGlobalSelectors from 'diseaseActivitiesGlobal/diseaseActivitiesGlobal.selectors';
import { sortDiseases } from 'diseaseActivitiesGlobal/diseaseActivitiesGlobal.slice';

import { GlobalDiseaseSearch } from './GlobalDiseaseSearch';

export const GlobalDiseaseActivitiesToolbar: React.FC = () => {
  const dispatch = useDispatch();
  const sortBy = useSelector<InsightsState, DiseaseListSortOptionValues>(
    diseaseActivitiesGlobalSelectors.getDiseaseActivitiesSortBy
  );

  return (
    <>
      <ViewPanelDropdown<DiseaseListSortOptionValues>
        selectedValue={sortBy}
        options={DiseaseActivitiesGlobalSortOptions}
        onSelect={opt => dispatch(sortDiseases(opt))}
      />
      <GlobalDiseaseSearch />
    </>
  );
};

export default GlobalDiseaseActivitiesToolbar;
